var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.335,
    height: 26.049,
    "data-name": "man (1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5dcb4",
    d: "m18.54 20.413-2.816-.866a1.27 1.27 0 0 1-.9-1.215v-2.027a.424.424 0 0 0-.424-.424H5.931a.424.424 0 0 0-.424.424v2.03a1.27 1.27 0 0 1-.9 1.215l-2.816.866a2.54 2.54 0 0 0-1.794 2.43v1.936a1.27 1.27 0 0 0 1.271 1.271h17.796a1.27 1.27 0 0 0 1.271-1.271v-1.936a2.54 2.54 0 0 0-1.795-2.433",
    "data-name": "Path 1352"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebc9a0",
    d: "M4.652 19.53c.658 1.8 2.874 3.13 5.515 3.13s4.857-1.328 5.515-3.13a1.27 1.27 0 0 1-.855-1.2v-2.025a.424.424 0 0 0-.424-.424H5.93a.424.424 0 0 0-.424.424v2.03a1.27 1.27 0 0 1-.854 1.195",
    "data-name": "Path 1353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2b496",
    d: "M14.404 15.881H5.931a.42.42 0 0 0-.309.138 5.5 5.5 0 0 0 9.091 0 .42.42 0 0 0-.309-.138",
    "data-name": "Path 1354"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5b97d",
    d: "M15.886 8.679h-.212V4.442H4.66v4.237h-.212a1.059 1.059 0 0 0 0 2.118h.233a5.5 5.5 0 0 0 10.972 0h.233a1.059 1.059 0 0 0 0-2.118",
    "data-name": "Path 1355"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5a4650",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.626 9.986a.424.424 0 0 1-.424-.424v-.424a.424.424 0 1 1 .847 0v.424a.423.423 0 0 1-.423.424",
    "data-name": "Path 1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71 9.986a.424.424 0 0 1-.424-.424v-.424a.424.424 0 1 1 .847 0v.424a.424.424 0 0 1-.423.424",
    "data-name": "Path 1357"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6e5a64",
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.049 8.255h-.847a.424.424 0 0 1 0-.847h.847a.424.424 0 1 1 0 .847",
    "data-name": "Path 1358"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.133 8.255h-.847a.424.424 0 1 1 0-.847h.847a.424.424 0 0 1 0 .847",
    "data-name": "Path 1359"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3aa75",
    d: "M13.557 4.866v-.424h-8.9v4.237h-.175a1.08 1.08 0 0 0-1.058.772 1.062 1.062 0 0 0 1.021 1.347h.233a5.47 5.47 0 0 0 6.336 5.012 5.5 5.5 0 0 1-4.663-5.436V7.832a2.12 2.12 0 0 1 2.118-2.118h4.236a.847.847 0 0 0 .852-.848",
    "data-name": "Path 1360"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5a4650",
    d: "M7.202.719a4.236 4.236 0 0 0-3.348 4.59l.358 3.394.437-.009a.847.847 0 0 0 .831-.847V6.136a1.27 1.27 0 0 1 1.271-1.271h4.688Z",
    "data-name": "Path 1361"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#84737b",
    d: "M13.556 11.22H6.778a1.27 1.27 0 0 0-1.271 1.271v.424a4.66 4.66 0 0 0 4.66 4.66 4.66 4.66 0 0 0 4.66-4.66v-.424a1.27 1.27 0 0 0-1.271-1.271",
    "data-name": "Path 1362"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#e3aa75",
    d: "M10.167 13.763a2.27 2.27 0 0 1-1.568-.546.424.424 0 0 1 .595-.6 1.72 1.72 0 0 0 1.947 0 .424.424 0 1 1 .595.6 2.27 2.27 0 0 1-1.569.546",
    "data-name": "Path 1363"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#6e5a64",
    "data-name": "Group 1173"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.625 12.915v-.424a1.27 1.27 0 0 1 1.271-1.271H6.778a1.27 1.27 0 0 0-1.271 1.271v.424a4.646 4.646 0 0 0 5.719 4.535 4.66 4.66 0 0 1-3.601-4.535",
    "data-name": "Path 1364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.095 8.7.358-3.394A4.236 4.236 0 0 0 12.237.629H8.045a6.54 6.54 0 0 1-3.062-.6.238.238 0 0 0-.355.208c0 1.25.593 4.625 6.806 4.625h2.118a1.27 1.27 0 0 1 1.271 1.271v1.714a.847.847 0 0 0 .831.847Z",
    "data-name": "Path 1365"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.9c27aee12edbacce9cca76124c464e06.svg";
export { ForwardRef as ReactComponent };